module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image6-059303ac9ebf0645602dd583737fbe01.png";